import PageShell from './PageShell';

const NotFound = () => {
  return (
    <PageShell className="not-found-page">
      <div className="container-fluid">
        <div className="content-wrapper">
          <div className="page-inner">
            <div className="not-found box extralight small-padding">
              <div className="row center">
                <div className="col-lg-7 col-md-9 col-sm-12 align-center">
                  <h1 className="not-found-title">Page not found</h1>
                  <p>The page you are looking for does not exist.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default NotFound;
